import { render } from "./BandeiraDePais.vue?vue&type=template&id=4b767fe5&scoped=true"
import script from "./BandeiraDePais.vue?vue&type=script&lang=js"
export * from "./BandeiraDePais.vue?vue&type=script&lang=js"

import "./BandeiraDePais.vue?vue&type=style&index=0&id=4b767fe5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b767fe5"]])

export default __exports__